import ModalBase from "./ModalBase";

export default function InstallInstructionsModal({ isOpen, onClose }) {
  return (
    <ModalBase isOpen={isOpen} title="Add DreamHome to Your Home Screen" onClose={onClose}>
      <div className="install-instructions">
        <h3>On iPhone (Safari)</h3>
        <ol>
          <li>Tap the Share icon at the bottom.</li>
          <li>Select “Add to Home Screen”.</li>
          <li>Tap “Add” to create the app icon.</li>
        </ol>

        <h3>On Android (Chrome)</h3>
        <ol>
          <li>Tap the menu (⋮) in the top-right.</li>
          <li>Select “Add to Home screen”.</li>
          <li>Confirm to create the app icon.</li>
        </ol>
      </div>
    </ModalBase>
  );
}
